import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { whatsappTemplateQuery } from "../../../lib/templates/whatsapp/whatsappTemplateQuery"

export const useDeleteWhatsappTemplateMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id }: { id: string }) => {
      const { data } = await axios.delete(`/integrations/whatsapp/templates/${id}`)

      queryClient.invalidateQueries({ queryKey: whatsappTemplateQuery({ id }).queryKey })

      return data.data
    },
  })
}
